import { render } from "./OrderCreateBatterySOHO.vue?vue&type=template&id=377b925c"
import script from "./OrderCreateBatterySOHO.vue?vue&type=script&lang=js"
export * from "./OrderCreateBatterySOHO.vue?vue&type=script&lang=js"

import "./OrderCreateBatterySOHO.vue?vue&type=style&index=0&id=377b925c&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__